import Dashboard from './Dashboard.vue';
import UserChangePassword from './user/ChangePassword.vue';
import CreateGraphic from './graphic.vue';

export default {
    path: '/dashboard',
    name: 'Dashboard',
    redirect: '/grafico',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: '/alterar-senha',
            name: 'change-password',
            component: UserChangePassword,
            meta: {
                requiresAuth: true,
                label: 'Alterar Senha'
            }
        },
        {
            path: '/grafico',
            name: 'create-graphic',
            component: CreateGraphic,
            meta: {
                requiresAuth: true,
                label: 'Gráfico'
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/views/router.js